import React from "react";
import { useCustomerDiscountModel } from "../customerDiscountModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useCustomerDiscountModel();
    const { getSelectedDict } = useGlobalModel(model => []);
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户优惠单号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: getSelectedDict(DictCodeEnmu.CUSTOMER_DISCOUNT)
        },
        {
            type: SearchTypeEnum.ScmRangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["申请起始日期", "申请结束日期"],
            format: "YYYY-MM-DD",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "申请人",
            fieldName: "createUser",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "机构审核人",
            fieldName: "audit",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "财务",
            fieldName: "casher",
        }
    ]

    return (
        <YhPageHeader
            title="客户优惠单"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}